import { render } from "./CommandCenter.html?vue&type=template&id=38eb6ec9&external"
import script from "./command_center.js?vue&type=script&lang=js&external"
export * from "./command_center.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__